<template>
  <div>
    <el-dialog title="新增章节信息" :visible.sync="openCardDialog">
      <el-form :model="form" label-width="35%">
        <el-form-item label="章节标题">
          <el-col :span="6">
            <el-input v-model="form.title"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="章节视频">
          <div style="float: left">
            <el-upload
                class="upload-demo"
                drag
                :http-request="handlePictureCardPreview"
                action="https://jsonplaceholder.typicode.com/posts/"
                multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text"><em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">文件大小建議不超80M,上传30M视频大概需要30S</div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-col :span="6">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";

export default {
  name: "AddChapterDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    form: '',
    fileUrl:""
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
      }
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  watch: {
    form: function (newVal, oldVal) {
      this.form = newVal;  //newVal即是uid
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      var newarr = file.file.name.split('.')

      console.log(newarr[1])
      var newname = file.file.uid + '.' + newarr[1];
      var file1 = new File([file.file], newname);
      console.log(file1,'----------')
      file.file = file1;
      this.fileList = file;
      var size = file.file.size;
      if (size/1024/1024 > 100) {
        Message.error('视频過大,上传失败');
      }
      this.fileUrl = URL.createObjectURL(file.file); // 图片上传浏览器回显地址
      console.log(this.fileUrl)
    },
    async save() {
      //判断是否有文件再上传
      if (this.fileList.length === 0) {
        return Message.error('请选取文件后再上传')
      }
      // 创建一个空的FormData对象:
      const formData = new FormData()
      // 使用FormData.append来添加键/值对到表单里面；
      formData.append('file', this.fileList.file)
      formData.append('chapter_title', this.form.title)
      formData.append('course_id', this.form.id)

      this.$http.post('/courses/chapter/add', formData).then(res => {
        if (res.data.code > 0) {
          Message.success('上传成功');
          setTimeout(() => {
            location.reload()
          }, 500);
        } else {
          Message.error('上传失败');
        }
      })
    }
  }
}
</script>
<style scoped>
</style>